export default theme => ({
    avatarContainer: {
        marginRight: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(0.5)
    },
    addressBox: {
        marginBottom: theme.spacing(1)
    },
    addressText: {
        fontWeight: 700,
        lineHeight: 1.1,
        fontSize: '1.1rem'
    },
    nameText: {
        fontWeight: 500,
        marginBottom: '8px'
    },
    stopCard: {
        marginBottom: 12,
        borderRadius: 12,
        backgroundColor: '#fff',
        opacity: 1
    },
    listItem: {
        padding: 16
    },
    divider: {
        marginBottom: '8px'
    },
    grid:{
        marginTop: '8px'
    },
    boxTypeGrid:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
});